import { useTranslation } from "react-i18next";
import SideBarItemList from "../../../components/uiPartials/sidebar/SideBarItemList";
import SolarCartLarge4Outline from "../../../components/icons/SolarCartLarge4Outline";
import SolarFolderLinear from "../../../components/icons/SolarFolderLinear";
import SolarBoxLinear from "../../../components/icons/SolarBoxLinear";
import SolarClipboardCheckOutline from "../../../components/icons/SolarClipboardCheckOutline";
import SolarChatRoundDotsLinear from "../../../components/icons/SolarChatRoundDotsLinear";
import SolarTicketLinear from "../../../components/icons/SolarTicketLinear";


const MarketSideBarMenu = () =>{
    const { t } = useTranslation(['Market', 'common']); 
    return (<>
        <SideBarItemList
            title={t('sideTitle')}
            icon={(<SolarCartLarge4Outline/>)}
            itemsList={[ 
                {label:t('sideItemCategory'), to:'/market/categories', startsWith:'/market/categor', icon:(<SolarFolderLinear/>)},
                {label:t('sideItemProduct'), to:'/market/products', startsWith:'/market/product', icon:(<SolarBoxLinear/>)}, 
                {label:t('sideItemOrders'), to:'/market/orders', icon:(<SolarClipboardCheckOutline/>)},
                {label:t('sideItemReviews'), to:'/market/reviews', startsWith:'/market/reviews', icon:(<SolarChatRoundDotsLinear/>)},
                {label:t('sideItemPromo'), to:'/market/promo', startsWith:'/market/promo', icon:(<SolarTicketLinear/>)}
            ]}/>
    </>); 
}

export default MarketSideBarMenu;   